import { Divider, Form } from 'antd';
import styled from 'styled-components';
import { black, blue01, blueDark01, blueLink } from '../../styles/colors';
import { BoldText } from '../../styles/common.styles';

export const BasicInfoForm = styled(Form)`
    margin-bottom: 40px;

    &:nth-child(2) {
        .ant-form-item-row {
            .ant-form-item-control-input-content {
                width: 354px;
                max-width: unset;
                flex: unset;

                & > span {
                    height: 36px;

                    & > input {
                        height: auto !important;
                    }
                }
            }
        }
    }
`;

export const BasicInfoRow = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const BasicInfoContainer = styled('div')`
    margin: 37px 100px 46px 100px;
    display: flex;
    flex-direction: column;
`;

export const BasicInfoColumn = styled('div')`
    display: flex;
    flex-direction: column;
    flex: 2;
`;

export const BasicInfoSection = styled('div')`
    display: flex;
    flex-direction: column;

    .input-block,
    & > div > div {
        & > div:first-child {
            margin-bottom: 0;
        }
        & > div:last-child {
            margin-bottom: 16px;
        }
        .ant-form-item-row {
            display: flex !important;
            gap: 16px;

            .ant-form-item-label {
                width: 125px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                label {
                    font-weight: normal;
                    font-family: 'Proxima N W15 Bold';
                    font-size: 13px;
                    line-height: 16px !important;
                    height: auto;
                    color: ${blueDark01} !important;
                    &::after {
                        margin-right: 0;
                    }
                }
            }

            .ant-form-item-control {
                input,
                .ant-select-selector {
                    width: 354px;
                    height: 36px;
                }

                .ant-form-item-explain-error {
                    top: 33px;
                }
            }
        }
    }
`;

export const BasicInfoPhoneInputContainer = styled('div')`
    display: flex;
    flex-direction: row;

    & > div {
        :nth-child(1) {
            .ant-form-item-row {
                .ant-form-item-control {
                    input {
                        width: 203px;
                    }
                }
            }
        }
        :nth-child(2) {
            .ant-form-item-row {
                .ant-form-item-label {
                    width: 48px;
                }
                .ant-form-item-control {
                    input {
                        width: 87px;
                    }
                }
            }
        }
    }
`;

export const BasicInfoPasswordContainer = styled('div')`
    & > div:last-child {
        .ant-form-item {
            margin-bottom: 0;
            .ant-form-item-label {
                height: auto;
            }
        }
    }
    .ant-form-item-label {
        width: 130px !important;
    }
`;

export const BasicInfoDivider = styled(Divider)`
    margin: 0px 0px 40px 0px;
`;

export const BasicInfoResetPassword = styled('div')`
    button {
        height: 16px;
    }
`;

export const GeneralBasicInformationTitle = styled('h2')`
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: ${blue01};
    font-family: 'DINNextLTPro';
`;

export const BasicInformationTitle = styled(GeneralBasicInformationTitle)`
    width: 154px;
`;

export const BasicPasswordTitle = styled(GeneralBasicInformationTitle)`
    width: 87px;
`;

export const OrganizationsFavoritesInputContainer = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 16px;
    margin-left: 24px;
`;

export const CheckboxContainer = styled('div')`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-bottom: 0;
`;

export const CheckboxRow = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: flex-end;
`;

export const CheckboxLabel = styled(BoldText)`
    text-align: right;
`;

export const InlineLink = styled('a')`
    color: ${blueLink};
    font-family: 'Proxima Nova';
    font-weight: 400;
    text-decoration: none;

    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }

    &:active {
        color: ${black};
        text-decoration: underline;
    }
`

export const SubscriptionInfoText = styled('span')``;

export const SubscriptionList = styled('ul')`
    margin: 0;
    padding-left: 20px;
`;

export const SubscriptionListItem = styled('li')``;

export const ChangeAdminRow = styled('div')`
    margin-top: 24px;
    margin-bottom: 20px;

    .input-block {
        > div:first-child {
            margin-bottom: 16px;
        }

        .ant-form-item-row {
            display: flex !important;
            gap: 16px;

            .ant-form-item-label {
                width: 100px;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                label {
                    text-align: right !important;
                    font-weight: normal;
                    font-family: 'Proxima N W15 Bold';
                    font-size: 13px;
                    line-height: 16px !important;
                    height: auto;
                    color: ${blueDark01} !important;

                    &::after {
                        margin-right: 0;
                        display: none;
                    }
                }
            }

            .ant-form-item-control {
                input,
                .ant-select-selector {
                    width: 354px;
                    height: 36px;
                }
            }
        }
    }
`;

export const AdminSelect = styled('select')`
    width: 354px;
    height: 36px;
`;
